<template>
  <div class="fzxw">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/cpzs_banner.png"
        alt=""
      >
    </div>
    <div class="content">
      <div class="xq w1200">
        <div class="rb" v-for="(item,i) in fzImg" :key="i" v-if="$route.query.id - 0 === i">
          <img :src="item.img1" alt="">
          <ul class="sm">
            <li>
              <img :src="item.img2" alt="">
              <p>公众号关注</p>
            </li>
            <li>
              <img :src="item.img3" alt="">
              <p>二维码下载</p>
            </li>
            <li class="ckrz" v-if="$route.query.id - 0 != '8'">
              <img :src="item.img4" alt="">
              <p>查看软著</p>
              <img class="rzxq" :src="item.img5" alt="">
            </li>
          </ul>
          <img class="rbb" :src="item.img6" alt="">
          <img :src="item.img7" alt="">
          <img @click="skip('http://icid.iachina.cn/?columnid_url=201509301401')" :src="item.img8" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fzxw',
  data () {
    return {
      fzImg: [
        {
          img1: require('../../static/img/fz_fz_tb.png'),
          img2: require('../../static/img/feizhubaoxian.jpg'),
          img3: require('../../static/img/fzbx_1.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/fz_rz.png'),
          img6: require('../../static/img/fz_fz_what.png'),
          img7: require('../../static/img/fz_fz_ys.png'),
          img8: require('../../static/img/fz_fz_tz.png'),
          id: '0'
        },
        {
          img1: require('../../static/img/fz_lhb_tb.png'),
          img2: require('../../static/img/lianhebao.jpg'),
          img3: require('../../static/img/lhb_1.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/lhb_rz.png'),
          img6: require('../../static/img/fz_lhb_what.png'),
          img7: require('../../static/img/fz_lhb_ys.png'),
          img8: require('../../static/img/fz_lhb_tz.png'),
          id: '1'
        },
        {
          img1: require('../../static/img/fz_lcb_tb.png'),
          img2: require('../../static/img/lichebao.jpg'),
          img3: require('../../static/img/lcb_1.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/lcb_rz.png'),
          img6: require('../../static/img/fz_lcb_what.png'),
          img7: require('../../static/img/fz_lcb_ys.png'),
          img8: require('../../static/img/fz_lcb_tz.png'),
          id: '2'
        },
        {
          img1: require('../../static/img/fz_zzb_tb.png'),
          img2: require('../../static/img/zizunbao.png'),
          img3: require('../../static/img/zzb_1.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/zzb_rz.png'),
          img6: require('../../static/img/fz_zzb_what.png'),
          img7: require('../../static/img/fz_zzb_ys.png'),
          img8: require('../../static/img/fz_zzb_tz.png'),
          id: '3'
        },
        {
          img1: require('../../static/img/fz_xe_tb.png'),
          img2: require('../../static/img/xiaoerbaoxian.jpg'),
          img3: require('../../static/img/xrbx_1.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/xe_rz.png'),
          img6: require('../../static/img/fz_xe_what.png'),
          img7: require('../../static/img/fz_xe_ys.png'),
          img8: require('../../static/img/fz_xe_tz.png'),
          id: '4'
        },
        {
          img1: require('../../static/img/fz_rb_tb.png'),
          img2: require('../../static/img/rebao.jpg'),
          img3: require('../../static/img/rb_1.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/rb_rz.png'),
          img6: require('../../static/img/fz_rb_what.png'),
          img7: require('../../static/img/fz_rb_ys.png'),
          img8: require('../../static/img/fz_rb_tz.png'),
          id: '5'
        },
        {
          img1: require('../../static/img/fz_thb_tb.png'),
          img2: require('../../static/img/taihuibao.jpg'),
          img3: require('../../static/img/thb_1.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/tb_rz.png'),
          img6: require('../../static/img/fz_thb_what.png'),
          img7: require('../../static/img/fz_thb_ys.png'),
          img8: require('../../static/img/fz_thb_tz.png'),
          id: '6'
        },
        {
          img1: require('../../static/img/fz_dlb_tb.png'),
          img2: require('../../static/img/dinglongbao.jpg'),
          img3: require('../../static/img/dlb_1.png'),
          img4: require('../../static/img/fz_zzb_rz.png'),
          img5: require('../../static/img/dlb_rz-2.png'),
          img6: require('../../static/img/fz_dlb_what.png'),
          img7: require('../../static/img/fz_dlb_ys.png'),
          img8: require('../../static/img/fz_dlb_tz.png'),
          id: '7'
        }
        // ,
        // {
        //   img1: require('../../static/img/gbb_1.jpg'),
        //   img2: require('../../static/img/gbb_2.png'),
        //   img3: require('../../static/img/gbb_3.png'),
        //   // img4: require('../../static/img/gbb_4.png'),
        //   // img5: require('../../static/img/gbb_4.png'),
        //   img6: require('../../static/img/gbb_4.jpg'),
        //   img7: require('../../static/img/fz_dlb_ys.png'),
        //   img8: require('../../static/img/fz_dlb_tz.png'),
        //   id: '8'
        // }
      ]
    }
  },
  methods: {
    skip (url) {
      location.href = url
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
    min-height: 3637px;
    height: auto;
    background-color: #ffffff;
    .xq {
        text-align: center;
        left: 50%;
        margin: 0 auto;
        position: absolute;
        transform: translateX(-50%) translateY(-100px);
        margin: 0 auto;
        background-color: #fff;
        img {
            display: block;
            margin: 0 auto;
        }
        .rb {
            position: relative;
            .sm {
                width: 600px;
                height: 190px;
                display: flex;
                position: absolute;
                top: 400px;
                padding: 0 30px;
                li {
                    width: 138px;
                    margin: 0 20px;
                    p {
                        font-size: 26px;
                        font-weight: 700;
                        color: #fff5fd;
                        text-align: center;
                        line-height: 60px;
                    }
                    img {
                        display: block;
                        width: 138px;
                        height: 138px;
                    }
                }
                .rzxq {
                    position: absolute;
                    top: -100px;
                    left: 300px;
                    display: none;
                    width: 416px;
                    height: 561px;
                }
                .ckrz:hover .rzxq {
                   display: block;
                    transition: all 1s;
                }
            }
            .rbb {
                margin: 60px auto;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Cpfz.vue